
import Vue from 'vue'
export default Vue.extend({
  props: {
    footerData: {
      type: Object,
      default: () => ({
        corporationInformation: ['4Team Corporation', '5645 Coral Ridge Dr #211', 'Coral Springs', 'FL 33076, USA'],
        buttons: [
          {
            id: 1,
            isExternal: true,
            name: 'FOOTER_BUTTON_NAME_1',
            link: 'URL_ABOUT_US',
            title: 'FOOTER_BUTTON_TITLE_1',
          },
          {
            id: 2,
            isExternal: true,
            name: 'FOOTER_BUTTON_NAME_2',
            link: 'https://www.4team.biz/termsandprivacy.aspx',
            title: 'FOOTER_BUTTON_TITLE_2',
          },
          {
            id: 3,
            isExternal: true,
            name: 'FOOTER_BUTTON_NAME_3',
            link: 'https://www.4team.biz/termsandprivacy.aspx',
            title: 'FOOTER_BUTTON_TITLE_3',
          },
        ],
        contacts: [
          {
            id: 1,
            name: 'USA:',
            number: '+1 (954) 796-8161',
          },
          
          {
            id: 2,
            name: 'Skype:',
            number: 'teamcorporation',
          },
        ],
        footerBottomTopText: 'FOOTER_BOTTOM_COPYRIGHT',
        corporationName: 'FOOTER_CORPORATION_NAME',
        footerBottomMainText: 'FOOTER_BOTTOM_MAIN_TEXT',
        footerInputLabel: 'FOOTER_INPUT_LABEL',
        footerInputPlaceholder: 'FOOTER_INPUT_PLACEHOLDER',
        teamLogo: {
          title: 'FOOTER_ICON_TEAM_LOGO_TITLE',
          isExternal: true,
          link: 'http://www.4team.biz',
        },
        validation: {
          required: 'VALIDATION_REQUIRED',
          emailInvalid: 'VALIDATION_EMAIL_INVALID',
        },
        footerDiscounts: 'FOOTER_DISCOUNTS',
      }),
    },
  },
  data() {
    return {
      isFormValid: false,
      emailAddress: '',
      date: (): number => new Date().getFullYear(),
    }
  },
  methods: {
    async subscribe() {
      if (!this.isFormValid) {
        return
      }
      await (this as any).$repositories.subscription.post(this.emailAddress)
    },
  },
})
